import { AgentData } from 'interfaces/AgentData';
import { JsonObject } from 'interfaces/JsonObject';
import { services } from 'services/container';

export const wsToChatAgent = (agent: JsonObject): AgentData => {
    const { agent_id, agent_name, agent_photo } = agent;

    return {
        id: String(agent_id),
        name: agent_name,
        avatar: agent_photo && services.vo.getThumbUrl(agent_photo),
    };
};
